module.exports = __webpack_public_path__ + "img/nabl_gallery8.395ed727.jpg";